import { FC, useState } from 'react';
import { useAppSelector } from '@redux/hooks';
import { SizeRowTypeProps } from './TypeProps';
import { ScrollBar } from '@ui-kit/ScrollBar';
import { Button, ButtonSize, ButtonThemes, LinkTheme, MyLink } from '@app/shared';
import { CarTag } from '../../module/types/brandSchema';
import { Htag } from '@ui-kit/Htag';
import classNames from 'classnames';
import IconArrow from './icons/Arrow.svg';

import styles from './SizeRow.module.scss';

export const SizeRow: FC<SizeRowTypeProps> = ({ className, classContainerItems, list, title }) => {
  const host = useAppSelector(state => state.header.data.host);
  const [active, setActive] = useState<string>('');
  const [links, setLink] = useState<CarTag[]>();

  const handleActiveSizeButton = (value: string) => {
    if (value === active) {
      setActive('');
    } else {
      const arrayList = list?.find(x => x?.title === value)?.tags;
      setActive(value);
      setLink(arrayList);
    }
  };

  return (
    <div className={classNames(styles.WrapperSizeRow, className)}>
      {title && <Htag tag={'h3'}>{title}</Htag>}
      <ScrollBar classContainer={styles.Container} type="horizontal">
        {list?.map(size => (
          <Button
            themes={ButtonThemes.FilterTab}
            size={ButtonSize.S}
            key={size?.title}
            active={size?.title && size?.title === active}
            onClick={() => handleActiveSizeButton(size?.title)}
          >
            {size?.title}
            <IconArrow className={classNames(styles.Icon, { [styles.active]: size?.title && size?.title === active })} width={11} height={14} />
          </Button>
        ))}
      </ScrollBar>
      {active && (
        <div className={classNames(styles.WrapperLinks, classContainerItems)}>
          {links?.map((item, index) => {
            return (
              <MyLink reloaded key={`${item?.title}_${index}`} href={host + item?.href} themes={LinkTheme.Theme8}>
                {item?.title}
              </MyLink>
            );
          })}
        </div>
      )}
    </div>
  );
};
